import { computed, Ref } from "vue";

import { useServices } from "@/configuration/plugins/app/app-provider.configuration";
import { V4HSiteId } from "@/data/common/ids";

export function useContactUrl(siteId: Ref<V4HSiteId | undefined>) {
  const { env } = useServices();

  const contactUrl = computed<string>(() => {
    if (!siteId.value) return "";

    return `${env.VITE_ZENDESK_CONTACT_URL}=${siteId.value}`;
  });

  return {
    contactUrl,
  };
}
